import React from 'react'
import { useTranslation } from 'react-i18next'

import cs from './i18n/cs.json'
import en from './i18n/en.json'

export interface ILoanDurationProps {
  monthsDuration: number
}

const LoanDuration = ({ monthsDuration }: ILoanDurationProps) => {
  const { t, i18n } = useTranslation('LoanDuration')
  i18n.addResourceBundle('cs', 'LoanDuration', cs)
  i18n.addResourceBundle('en', 'LoanDuration', en)

  const durationInYearsAndMonths = (): string => {
    const years = parseInt(String(monthsDuration / 12), 10)
    const months = monthsDuration % 12
    const arr = []

    if (years) {
      arr.push(t('YEARS', { smart_count: years }))
    }
    if (months) {
      arr.push(t('MONTHS', { smart_count: months }))
    }
    return arr.join(', ')
  }

  const spToNbsp = (text: string) => text.replace(/ /g, '\u00a0')

  return <>{spToNbsp(durationInYearsAndMonths())}</>
}

export default LoanDuration
